import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import '../Styles/ContactForm.css';

export function ContactForm({ isOpen, onClose }) {
	const [status, setStatus] = useState("");
	const [statusType, setStatusType] = useState("");
	const [isMouseDownOnOverlay, setIsMouseDownOnOverlay] = useState(false);

	useEffect(() => {
		if (!isOpen) return;
		const handleEsc = (e) => { if (e.key === 'Escape') onClose(); };
		window.addEventListener('keydown', handleEsc);
		document.body.style.overflow = 'hidden';
		return () => {
			window.removeEventListener('keydown', handleEsc);
			document.body.style.overflow = 'unset';
		};
	}, [isOpen, onClose]);

	const handleSubmit = async (e) => {
		e.preventDefault();
		const form = e.target;
		const data = new FormData(form);
		setStatus("Sending...");

		try {
			const response = await fetch("https://formspree.io/f/mgoooeae", {
				method: 'POST',
				body: data,
				headers: { 'Accept': 'application/json' }
			});

			if (response.ok) {
				setStatusType("success");
				setStatus("Thanks! Your message has been sent.");
				form.reset();
				setTimeout(() => {
					onClose();
					setStatus("");
				}, 3000);
			} else {
				throw new Error();
			}
		} catch (error) {
			setStatusType("error");
			setStatus("Oops! There was a problem sending your message.");
		}
	};

	if (!isOpen) return null;

	return createPortal(
		<div
			className="contact-modal-overlay"
			onMouseDown={(e) => {
				if (e.target.classList.contains('contact-modal-overlay')) {
					setIsMouseDownOnOverlay(true);
				}
			}}
			onMouseUp={(e) => {
				if (isMouseDownOnOverlay && e.target.classList.contains('contact-modal-overlay')) {
					onClose();
				}
				setIsMouseDownOnOverlay(false);
			}}
		>
			<div className="contact-box" onClick={(e) => e.stopPropagation()}>
				<span className="close-contact" onClick={onClose}>&times;</span>
				<h2>Contact Me</h2>
				<form onSubmit={handleSubmit} className="contact-form">
					<div className="form-group">
						<input type="text" name="name" placeholder="Your Name" required />
					</div>
					<div className="form-group">
						<input type="email" name="email" placeholder="Your Email" required />
					</div>
					<div className="form-group">
						<textarea name="message" placeholder="Your Message" rows="5" required></textarea>
					</div>
					<button type="submit" className="submit-btn">Send Message</button>
					{status && <p className={`form-status ${statusType}`}>{status}</p>}
				</form>
			</div>
		</div>,
		document.body
	);
}